import CryptoJS from 'crypto-js';

// Encode (encrypt)
export function EncodeData(input) {
    var secretKey = process.env.REACT_APP_AES_SECRET_KEY;
    return CryptoJS.AES.encrypt(input, secretKey).toString();
}

// Decode (decrypt)
export function DecodeData(encrypted) {
    var secretKey = process.env.REACT_APP_AES_SECRET_KEY;
    const bytes = CryptoJS.AES.decrypt(encrypted, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
}